import React, { useEffect } from "react";
import styles from "./ricky.module.css";
import { NavLink, useLocation } from "react-router-dom";

function Ricky({ children }) {
  const location = useLocation();
  useEffect(() => {}, []);
  const atRoot = location.pathname === "/dashboard/ricky";
  return (
    <div className="dashboard-page d-flex">
      <div className={`${styles.sidebarShell} d-flex flex-column`}>
        <nav className={`${styles.sidebarContainer} nav flex-column`}>
           <NavLink
            to="/dashboard/ricky/arg/p"
            className={({ isActive }) =>
              `nav-link ${styles.sidebarLink} ${
                isActive || atRoot ? styles.sidebarLinkActive : ""
              }`
            }
          >
            Ricky ARG Products
          </NavLink>

          <NavLink
            to="/dashboard/ricky/us/p"
            className={({ isActive }) =>
              `nav-link ${styles.sidebarLink} ${
                isActive ? styles.sidebarLinkActive : ""
              }`
            }
          >
            Ricky US Products
          </NavLink>
          <NavLink
            to="/dashboard/ricky/arg/o"
            className={({ isActive }) =>
              `nav-link ${styles.sidebarLink} ${
                isActive ? styles.sidebarLinkActive : ""
              }`
            }
          >
            Ricky ARG Ordenes
          </NavLink>
          <NavLink
            to="/dashboard/ricky/us/o"
            className={({ isActive }) =>
              `nav-link ${styles.sidebarLink} ${
                isActive ? styles.sidebarLinkActive : ""
              }`
            }
          >
            Ricky US Ordenes
          </NavLink>
        </nav>
      </div>
      <div className={`${styles.contentPane} flex-grow-1`}>
        {children}
      </div>
    </div>
  );
}

export default Ricky;
